<template>
    <!--Newsletter content-->
    <div class="myskov-newsletter">
        <div class="profile-block">
            <div class="profile-block__heading">
                <h3 v-text="translations.title"></h3>
            </div>
            <div class="profile-block__text">
                <p v-text="translations.description"></p>
            </div>
            <checkbox v-if="customer.subscribeNewsletter !== null" :name="translations.input_checkbox" :value="customer.subscribeNewsletter" @checked="changeNewsletterValue"></checkbox>
            <msg-block v-if="success">
                <p v-text="translations.success_msg"></p>
            </msg-block>
            <msg-block v-if="error" type="error">
                <p><b v-text="error"></b></p>
            </msg-block>
        </div>
    </div>
</template>

<script>
import Checkbox from '../checkbox.vue';
import SkovApi from '../../skovapi.js';
import MsgBlock from '../msg-block.vue';

export default {
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.MYSKOV_NEWSLETTER,
            customer: {
                subscribeNewsletter: null
            },
            loading: true,
            success: false,
            error: null
        }
    },
    mounted() {
        this.loading = true;

        this.$store.dispatch('getUser').then((user) => {
            this.customer = user;
            this.loading = false;
        }).catch((error) => {
            this.loading = false;
        })
    },
    methods: {
        changeNewsletterValue(value) {
            if(this.loading)
                return;

            this.error = null;
            this.success = false;
            this.loading = true;
            this.customer.subscribeNewsletter = value;
            SkovApi.updateUser(this.customer).then((res) => {
                this.$store.dispatch('getUser').then((user) => {
                    this.customer = user;
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                })
            }).catch((error) => {
                console.error(error);
                this.customer.subscribeNewsletter = !value;
                this.error = this.translations.ERRORS.customer_update;
                this.loading = false;
            });
        }
    },
    components: {
        Checkbox,
        MsgBlock
    }
}
</script>
